import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const VideoChannel = () => {
  const { username } = useParams();
  const navigate = useNavigate();
  const [channel, setChannel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subscribed, setSubscribed] = useState(false);
  const [subscribers, setSubscribers] = useState(0);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const fetchChannel = async () => {
      try {
        const headers = token ? { Authorization: `Token ${token}` } : {};
        const res = await axios.get(`/api/videos/channel/${username}/`, { headers });
        setChannel(res.data);
        setSubscribed(res.data.is_subscribed);
        setSubscribers(res.data.subscribers);
      } catch (err) {
        console.error(err);
      }
      setLoading(false);
    };
    fetchChannel();
  }, [username]);

  const handleSubscribe = async () => {
    if (!token) return alert('Please login first');
    try {
      const res = await axios.post(`/api/videos/channel/${username}/subscribe/`, {}, {
        headers: { Authorization: `Token ${token}` }
      });
      setSubscribed(res.data.subscribed);
      setSubscribers(res.data.subscribers);
    } catch (err) {
      console.error(err);
    }
  };

  const formatDuration = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, '0')}`;
  };

  if (loading) return <div style={{ color: '#aaa', textAlign: 'center', padding: '40px' }}>Loading...</div>;
  if (!channel) return <div style={{ color: '#aaa', textAlign: 'center', padding: '40px' }}>Channel not found</div>;

  return (
    <div style={{ padding: '0', maxWidth: '1200px', margin: '0 auto' }}>
      <button onClick={() => navigate('/videos')} style={{ background: 'transparent', border: 'none', color: '#aaa', cursor: 'pointer', margin: '20px', fontSize: '14px' }}>
        ← Back to Videos
      </button>

      {/* Channel Banner */}
      <div style={{ background: 'linear-gradient(135deg, #1a1a2e, #16213e)', padding: '40px 24px', textAlign: 'center', marginBottom: '24px' }}>
        <div style={{ width: '80px', height: '80px', borderRadius: '50%', background: '#0F6E56', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '32px', margin: '0 auto 16px', fontWeight: 'bold', color: '#000' }}>
          {username[0].toUpperCase()}
        </div>
        <h2 style={{ color: '#fff', margin: '0 0 8px', fontSize: '24px' }}>@{channel.username}</h2>
        <div style={{ color: '#aaa', fontSize: '14px', marginBottom: '16px', display: 'flex', justifyContent: 'center', gap: '20px' }}>
          <span>🎬 {channel.total_videos} Videos</span>
          <span>👥 {subscribers} Subscribers</span>
        </div>
        <button
          onClick={handleSubscribe}
          style={{
            background: subscribed ? '#333' : '#0F6E56',
            color: subscribed ? '#aaa' : '#000',
            border: 'none',
            borderRadius: '20px',
            padding: '10px 24px',
            fontWeight: '600',
            cursor: 'pointer',
            fontSize: '14px'
          }}
        >
          {subscribed ? '✓ Subscribed' : '+ Subscribe'}
        </button>
      </div>

      {/* Videos Grid */}
      <div style={{ padding: '0 20px 20px' }}>
        {channel.videos.length === 0 ? (
          <div style={{ color: '#aaa', textAlign: 'center', padding: '40px' }}>No videos yet</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
            {channel.videos.map(v => (
              <div key={v.id} onClick={() => navigate(`/videos/${v.id}`)} style={{ background: '#1e2a3a', borderRadius: '12px', overflow: 'hidden', cursor: 'pointer' }}>
                <div style={{ position: 'relative' }}>
                  {v.thumbnail_url ? (
                    <img src={v.thumbnail_url} alt={v.title} style={{ width: '100%', height: '160px', objectFit: 'cover' }} />
                  ) : (
                    <div style={{ width: '100%', height: '160px', background: '#0d1b2a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '40px' }}>🎬</div>
                  )}
                  <span style={{ position: 'absolute', bottom: '8px', right: '8px', background: 'rgba(0,0,0,0.8)', color: '#fff', padding: '2px 6px', borderRadius: '4px', fontSize: '12px' }}>
                    {formatDuration(v.duration)}
                  </span>
                </div>
                <div style={{ padding: '12px' }}>
                  <div style={{ color: '#fff', fontWeight: 'bold', fontSize: '14px', marginBottom: '6px' }}>{v.title}</div>
                  <div style={{ color: '#aaa', fontSize: '12px' }}>👁 {v.views_count} views</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoChannel;
